import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";

import pricingStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/pricingStyle.jsx";
import Link from "react-router-dom/Link";
import TranslationService from "../../../services/translation/TransationService";
import RatingScoreCard from "../../../components/RatingScoreCard/RatingScoreCard";

function SectionFacilities({ ...props }) {
  const { classes, facilities, seeMore, allResults, ...rest } = props;

  return (
    <div className="cd-section" {...rest}>
      <div className={classes.container} style={{ textAlign: "center" }}>
        <GridContainer>
          {facilities.map((facility, key) => (
            <GridItem key={key} sm={12} md={6} lg={4}>
              <Card pricing raised>
                <CardBody pricing>
                  <div
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      maxWidth: "320px"
                    }}
                  >
                    <h6
                      className={`${classes.cardDescription} ${
                        classes.marginBottom20
                      }`}
                    >
                      <RatingScoreCard
                        scoreNumber={facility.score}
                        lastAutoevaluationDate={new Date(facility.lastAutoevaluationDate)}
                      />
                    </h6>
                  </div>
                  <h3 className={`${classes.cardTitle} ${classes.marginTop40}`}>
                    {facility.companyName}
                  </h3>
                  <p className={classes.cardDescription}>{facility.address}</p>
                  <Link to={"/facilities/" + facility.id}>
                    <Button round color="primary">
                      {TranslationService.get("SEARCH.RESULTS.MORE_INFO")}
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
        <br />
        <br />
        <Button
          round
          disabled={allResults}
          color={allResults ? " " : "warning"}
          onClick={seeMore}
        >
          {TranslationService.get("SEARCH.RESULTS.VIEW_MORE")}
        </Button>
        <br />
        <br />
        <br />
      </div>
    </div>
  );
}

export default withStyles(pricingStyle)(SectionFacilities);



// WEBPACK FOOTER //
// ./src/views/QxQPublicPage/Sections/SectionFacilities.jsx